<template>
  <div class="about-container">
    <div class="about-item">
      <img class="about-image" src="../assets/logo.png" alt="患者端图片">
      <h3 class="about-title">{{WebName}}</h3>
      <p class="about-description">型号规格：BrainTumorCare-W</p>
      <p class="about-description">发布版本号：1</p>
      <p class="about-description">完整版本号：1.0.0</p>

      <!-- <el-button class="about-btn" type="primary" @click="aboutPatient">下载 {{patientApk.version}}</el-button> -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'AboutPage',
  data() {
    return {
      WebName: '爱勇者（医生和管理端）Web软件',
      patientApk: {
        deviceType: '爱勇者（患者端）',
        version: '',
        url: '',
        uploadTime: ''
      },
      doctorApk: {
        deviceType: '爱勇者（医生和管理端）',
        version: '',
        url: '',
        uploadTime: ''
      }
    }
  },
  mounted() {
    this.getaboutData()
  },
  methods: {

  }
}
</script>

<style scoped>
.about-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
  max-width: 100%; /* 或者你想要的宽度 */
}

.about-item {
  margin-bottom: 20px; /* 控制下载项之间的间距 */
  text-align: center; /* 如果需要的话，让内容居中 */
}

.about-title {
  margin-bottom: 10px; /* 软件名称与图片之间的间距 */
}

.about-image {
  width: 100px; /* 或者你想要的宽度 */
  height: 100px; /* 或者你想要的高度 */
  margin-bottom: 10px; /* 图片与描述之间的间距 */
  object-fit: cover; /* 保持图片比例 */
}

.about-description {
  margin-bottom: 20px; /* 描述与下载按钮之间的间距 */
  text-align: left; /* 如果需要的话，让内容居中 */
}



</style>